import React, { useEffect, useState } from "react";
import { IoDocumentSharp } from "react-icons/io5";
import Heading from "../../../utils/Heading";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormCtx } from "../../../../context/formContext/formContext";
import Controls from "../../../controls/Control";
import Documents from "./Documents";
import { toast } from "react-toastify";
import Footer from "../../../footer/Footer";
import Declaration from "./Declaration";
import { customFetch } from "../../../../utils/http";
import Modal from "./Modal";

const SectionFour = () => {
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const { state, coporateInfo, hasFileErrors } = useFormCtx();
  const [agreedToPrivacy, setAgreedToPrivacy] = useState(false);

  const navigate = useNavigate();

  const {
    authorizedSignatory1,
    designation1,
    authorizedSignatory2,
    designation2,
    signatoryDate,
    nameOfDeclarator,
    declaratorDate,
    declaratorPosition,
  } = coporateInfo[0];

  const { documents } = state;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const signatories = [
    {
      authorizedSignatory1: {
        name: authorizedSignatory1,
        designation: designation1,
      },
      authorizedSignatory2: {
        name: authorizedSignatory2,
        designation: designation2,
      },
      signatoryDate: signatoryDate,
    },
  ];

  const declarator = [
    {
      declaration: {
        name: nameOfDeclarator,
        date: declaratorDate,
        position: declaratorPosition,
      },
    },
  ];

  const handleFileErrors = () => {
    const fileErrors = {};

    Object.entries(documents[0]).forEach(([key, value]) => {
      if (key !== "otherRelevantLicenseDoc" && !value) {
        fileErrors[key] = true;
      }
    });

    return fileErrors;
  };

  const handleSubmitHere = async (e) => {
    e.preventDefault();

    setLoading(true);

    const fileErrors = handleFileErrors();

    if (Object.keys(fileErrors).length > 0) {
      toast.error("Please fill all required fields in the Documents section", {
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
      });
      setLoading(false);
      return;
    }

    if (hasFileErrors()) {
      toast.error("UPLOAD ALL REQUIRED FILES", {
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
        theme: "dark",
      });
      setLoading(false);
      return;
    }

       if (!documents?.[0]) {
  toast.error("No files attached");
  return;
}

    // formData instance for documents and declarators
    const formDataDocSig = new FormData();
    const legalName = localStorage.getItem("ln");
    formDataDocSig.append("legalName", legalName);
    formDataDocSig.append("signatories", JSON.stringify(signatories));
    formDataDocSig.append("declarator", JSON.stringify(declarator));

    Object.entries(documents?.[0] || []).forEach(([key, value]) => {
      if(
          value &&
          value.size &&
          value.size <= 1024 * 1024 &&
        
        (value instanceof File || value instanceof Blob)){

        formDataDocSig.append(key, value);
      }
    });
    

    // end of instance

    try {
      const { data } = await customFetch.post(
        "v2nclientspostAndUploadFiles",
        formDataDocSig
      );

      if (!data?.message || data.message !== "sent successfully") {
        toast.error(data, {
          position: "top-center",
          autoClose: 5000,
          closeOnClick: true,
          draggable: true,
        });
        setErrorModal(true);
      } else {
        toast.success("Successfully submitted!", {
          position: "top-center",
          autoClose: 4000,
          closeOnClick: true,
          draggable: true,
        });
        setTimeout(() => {
          navigate("/success");
        }, 4000);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
      });
      setErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      {errorModal && (
        <Modal title="Error Occurred" onClose={() => setErrorModal(false)}>
          <p>There was an error during submission. Please try again later.</p>
        </Modal>
      )}
      <div className="flex items-center space-x-2 heading">
        <IoDocumentSharp className="text-2xl font-bold text-red-600" />
        <Heading text="Documents" />
      </div>
      <section className="documents ">
        <header>
          <h1 className="py-8 text-xl font-bold text-red-600">
            Maximum size of documents to be uploaded should be 1MB (in PDF &
            DOCX)
          </h1>
        </header>
        <form onSubmit={handleSubmitHere} encType="multipart/form-data">
          <div className="sections">
            <div className="px-6 md:px-2">
              <Documents />
            </div>
            <main className="px-8 py-6 bg-black rounded shadow-md ">
              <Declaration />
              <div className="flex items-center gap-2 text-white">
                <input
                  type="checkbox"
                  id="privacyCheck"
                  checked={agreedToPrivacy}
                  onChange={(e) => setAgreedToPrivacy(e.target.checked)}
                  className="w-4 h-4"
                />
                <label htmlFor="privacyCheck" className="text-sm">
                  By clicking this checkbox, you are agreeing to the processing
                  of your data. Kindly click{" "}
                  <a
                    href="https://vas2nets.com/docs/Privacy%20Policy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 underline hover:text-blue-300"
                  >
                    this link
                  </a>{" "}
                  to read more about our data privacy policies.
                </label>
              </div>
            </main>
          </div>

          <Controls back={4} loading={loading} agreedToPrivacy={agreedToPrivacy} last={true} />
          <Footer />
        </form>
      </section>
    </section>
  );
};

export default SectionFour;
